import featureFlags from '../constants/featureFlags';
import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "pointchangehistory",
    tagSub: "pointchangehistory",
    exact: false,
    path: PATHS.POINT_CHANGE_HISTORY.path,
    show: true,
    icon: "container",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.POINT_CHANGE_HISTORY,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "pointchangehistory",
            group: "pointchangehistory",
            path: PATHS.POINT_CHANGE_HISTORY.LIST.path,
            tagSub: "pointchangehistory",
            exac: false,
            icon: "container",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.POINT_CHANGE_HISTORY,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        },
    ]
}]
